/** Per-browser conveniences only (AGENT.md §13): never the source of truth. */
export const LAST_PROJECT_KEY = "music-platform:lastProjectId";
export const WORKSPACE_KEY = "music-platform:workspace";

export function safeStorageGet(key: string): string | null {
  try { return globalThis.localStorage?.getItem(key) ?? null; } catch { return null; }
}

export function safeStorageSet(key: string, value: string): void {
  try { globalThis.localStorage?.setItem(key, value); } catch { /* ignore */ }
}
